import { createActions } from 'redux-actions';
import { GetInsurancePolicyParams } from '@apis/InsurancePolicyApi';
import { InsurancePolicy } from '@models/InsurancePolicy';

export type State = {
  policy?: InsurancePolicy;
}

export type InsurancePolicyFetchPayload = GetInsurancePolicyParams;
export type StateUpdatePayload = Partial<State>;

export const {
  insurancePolicyFetch,
  stateUpdate,
} = createActions(
  'INSURANCE_POLICY_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_INSURANCE_POLICY_DETAILS_PAGE',
  },
);
